import React from 'react';
import './Card.css';

const Card = ({ title, description, onClick, arrowIcon, url }) => {
  const handleClick = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div 
      className="card" 
      onClick={handleClick}
      data-name="Card"
    >
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
      <div className="card-footer">
        <span className="card-read-text">Read</span>
        <div className="card-icon" data-name="solar:arrow-right-up-linear">
          <img src={arrowIcon} alt="external link" />
        </div>
      </div>
    </div>
  );
};

export default Card;

